import { render, staticRenderFns } from "./FlopCom.vue?vue&type=template&id=50cbfef1"
import script from "./FlopCom.vue?vue&type=script&lang=js"
export * from "./FlopCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports